(() => {
  'use strict';

  if (window.CVPopupManager) return;

  const queue = [];
  let active = null;
  let retryTimer = null;

  function isElementVisible(element) {
    if (!(element instanceof HTMLElement)) return false;
    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
  }

  function hasUnmanagedBlockingLayer() {
    const selectors = [
      '#card-modal',
      '#qr-modal',
      '#scroll-popup-modal',
      'dialog[open]',
      '[aria-modal="true"][aria-hidden="false"]',
      '.customer-data-popup.active',
    ];
    return selectors.some((selector) =>
      Array.from(document.querySelectorAll(selector)).some((element) => {
        if (active?.element && active.element.contains(element)) return false;
        return isElementVisible(element);
      })
    );
  }

  function sortQueue() {
    queue.sort((a, b) => b.priority - a.priority || a.requestedAt - b.requestedAt);
  }

  function scheduleRetry() {
    if (retryTimer !== null) return;
    retryTimer = window.setTimeout(() => {
      retryTimer = null;
      processQueue();
    }, 750);
  }

  function processQueue() {
    if (active || queue.length === 0) return;
    if (hasUnmanagedBlockingLayer()) {
      scheduleRetry();
      return;
    }
    sortQueue();
    const request = queue.shift();
    active = request;
    try {
      const opened = request.open();
      if (opened === false) {
        active = null;
        document.dispatchEvent(new CustomEvent('cv:popup-manager:failed', {
          detail: { id: request.id, reason: request.reason },
        }));
        window.setTimeout(processQueue, 0);
        return;
      }
      document.dispatchEvent(new CustomEvent('cv:popup-manager:opened', {
        detail: { id: request.id, reason: request.reason },
      }));
    } catch (error) {
      console.error('[CoolVita Popup Manager] Failed to open popup:', error);
      active = null;
      processQueue();
    }
  }

  function request({ id, priority = 0, reason = 'auto', open, element = null }) {
    if (!id || typeof open !== 'function') return false;
    if (active?.id === id || queue.some((item) => item.id === id)) return false;
    queue.push({ id, priority, reason, open, element, requestedAt: Date.now() });
    document.dispatchEvent(new CustomEvent('cv:popup-manager:requested', {
      detail: { id, reason },
    }));
    processQueue();
    return true;
  }

  function release(id) {
    if (active?.id === id) {
      active = null;
      document.dispatchEvent(new CustomEvent('cv:popup-manager:closed', { detail: { id } }));
      window.setTimeout(processQueue, 500);
      return;
    }
    const index = queue.findIndex((item) => item.id === id);
    if (index >= 0) queue.splice(index, 1);
  }

  function cancel(id) {
    const index = queue.findIndex((item) => item.id === id);
    if (index >= 0) queue.splice(index, 1);
  }

  window.CVPopupManager = {
    request,
    release,
    cancel,
    notifyStateChanged: processQueue,
    getActiveId: () => active?.id || null,
  };

  document.addEventListener('cv:growth-plan-popup:closed', processQueue);
  document.addEventListener('click', () => window.setTimeout(processQueue, 0));
})();
